"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Filter = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const __1 = require("../");
const styled_components_1 = require("../../styled-components");
const Filter = ({ size = 16, fill, ...rest }) => {
    const theme = (0, styled_components_1.useTheme)();
    fill = fill || theme.icon;
    return (react_1.default.createElement(__1.Base, { size: size, viewBox: "0 0 64 64", fill: fill, ...rest },
        react_1.default.createElement("path", { d: "M6 2l21 21v25l10 10V23L58 2z" })));
};
exports.Filter = Filter;
//# sourceMappingURL=index.js.map